// Stable positions in a shared sky, measured in viewport widths.
export const SIGN_SPACING = 1.25;
export function advanceJourney(state, target, dt, snap = false) {
  if (target < 0) return;
  if (state.target !== target) { state.target = target; state.reveal = 0; }
  const destination = target * SIGN_SPACING;
  state.camera += (destination - state.camera) * (snap ? 1 : 1 - Math.exp(-dt / 0.38));
  if (snap) state.reveal = 1;
  else if (Math.abs(destination - state.camera) < 0.07) state.reveal = Math.min(1, state.reveal + dt / 2.4);
}
export function linkProgress(reveal, index, count) {
  return Math.max(0, Math.min(1, (reveal - index / Math.max(1, count) * 0.22) / 0.3));
}
